import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/raleway/400.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@fontsource/raleway/700.css");
